import { useState } from "react"

const TRUE = "TRUE"
const FALSE = "FALSE"

export default function useTogglePersist(
  name: string,
  initialValue?: boolean
): [boolean, () => void, (value: boolean) => void] {
  const [value, setValue] = useState<boolean>(() => {
    const storedValue = localStorage.getItem(name)
    return storedValue !== null
      ? JSON.parse(storedValue) === TRUE
      : !!initialValue
  })

  function toggleValue() {
    setValue((prev) => {
      const newValue = prev ? FALSE : TRUE
      localStorage.setItem(name, JSON.stringify(newValue))
      return !prev
    })
  }

  return [value, toggleValue, setValue]
}
